// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__4hKf7","alignRightCell":"styles_alignRightCell__QREjT","row":"styles_row__8KPhO","titleWrap":"styles_titleWrap__nOwQe","wrapRight":"styles_wrapRight__38pcL"};